import React, { useEffect, useState } from 'react';
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import SortableList, { SortableItem } from "react-easy-sort";
import ActionComponent from "../../pages/Activity/Component/ActionComponent";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import { confirmModal } from '../../helpers/PromptUtils';
import { getToken } from '../../helpers/Jwt';

const FormComponent = ({ elements, elementClass, requestOnload, request, enableCustom, callSort }) => {
    const navigate = useNavigate();
    const { params } = useParams();

    const [initialValues, setInitialValues] = useState({});
    const [validationSchema, setValidationSchema] = useState(Yup.object());
    const [hasFetched, setHasFetched] = useState(false); // Track if data has been fetched

    useEffect(() => {
        if (hasFetched || !requestOnload || !elements || params == undefined) return;

        const fetchData = async () => {
            try {
                const response = await axios({
                    method: 'GET',
                    url: `${process.env.REACT_APP_API_BASE_URL}api/dashboard/request?url=${requestOnload.url}&id=${params}`
                });

                const data = response?.data?.result || {};

                // Set initial values based on the API response
                const newInitialValues = {};

                elements.forEach(input => {
                    const attributes = input.action_attribute;
                    const nameField = attributes.find(attr => attr.key === 'name');

                    if (nameField) {
                        // Assign initial values based on the API response or default to empty string
                        newInitialValues[nameField.value] = data[nameField.value] || '';
                    }
                });

                console.log(newInitialValues);
                
                setInitialValues(newInitialValues);

                // Dynamically create validation schema based on element types
                const schemaObject = {};

                elements.forEach(input => {
                    const attributes = input.action_attribute;
                    const nameField = attributes.find(attr => attr.key === 'name');
                    const typeField = attributes.find(attr => attr.key === 'type');
                    const labelField = attributes.find(attr => attr.key === 'placeholder');

                    if (nameField && typeField && labelField) {
                        let yupType;
                        switch (typeField.value) {
                            case 'date':
                                yupType = Yup.date();
                                break;
                            case 'number':
                                yupType = Yup.number();
                                break;
                            default:
                                yupType = Yup.string(); // default type
                        }
                        schemaObject[nameField.value] = yupType.required(`${labelField.value} wajib diisi`);
                    }
                });

                setValidationSchema(Yup.object().shape(schemaObject));
                setHasFetched(true); // Mark as fetched
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [hasFetched, requestOnload, elements, params]); // Only run if `requestOnload`, `elements`, or `params` change, but `hasFetched` prevents re-fetching

    const onSubmitComponent = async (values, { setSubmitting }) => {
        values['url'] = request.url;
        values['id'] = params;
        try {
            try {
                if (request?.integration == "Y") {
                    await axios({
                        method: request.method,
                        url: request.url,
                        data : values,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${getToken()}`
                        }
                    });    
                    const confirmed = confirmModal("Simpan Data Berhasil, Kembali ke Halaman sebelumnya?");
                    if (confirmed) {
                        navigate(-1);
                    }                             
                } else {
                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/dashboard/request`, values, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${getToken()}`
                        }
                    });
                    const confirmed = confirmModal("Simpan Data Berhasil, Kembali ke Halaman sebelumnya?");
                    if (confirmed) {
                        navigate(-1);
                    }
                }
            } catch (error) {
                alert(error.response.data);
            } finally {
                // window.location.reload();
            }    
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Error submitting form: ' + error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmitComponent}
                enableReinitialize 
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <SortableList
                            allowDrag={enableCustom}
                            onSortEnd={callSort}
                            // className="list"
                            className={elementClass}
                            draggedItemClassName="dragged"
                        >
                            {elements.map((action, index) => {
                                const nameAttribute = action.action_attribute.find(attr => attr.key === 'name');
                                const typeAttribute = action.action_attribute.find(attr => attr.key === 'type');          
                                
                                return (
                                    <SortableItem key={action.id} index={index}>
                                        <div style={{ cursor: 'pointer' }}>                                            
                                            <ActionComponent
                                                callChange={(value) => {
                                                    if (typeAttribute.value === 'text') {
                                                        setFieldValue(nameAttribute.value, value);                                                        
                                                    } else if (typeAttribute.value === 'textarea_rich') {
                                                        setFieldValue(nameAttribute.value, value);                                                        
                                                    } else if (typeAttribute.value === 'image') {
                                                        setFieldValue(nameAttribute.value, value);                                                        
                                                    }                                  
                                                }}
                                                key={index}
                                                action={action}
                                                custom={enableCustom}
                                            />
                                        </div>
                                    </SortableItem>
                                );
                            })}
                        </SortableList>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default FormComponent;